/* ============================================================
   Gloam product JS — variant selection + media gallery.
   Works for main-product and featured-product sections (each
   wraps itself in [data-product-wrapper] with a JSON script
   tag of the product's variants).
   ============================================================ */
(function () {
  'use strict';

  function moneyFormat(cents, format) {
    var value = (cents / 100).toFixed(2);
    if (format && format.indexOf('{{') !== -1) {
      return format
        .replace(/\{\{\s*amount\s*\}\}/, Number(value).toLocaleString(undefined, { minimumFractionDigits: 2 }))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toLocaleString());
    }
    return '$' + value;
  }

  document.querySelectorAll('[data-product-wrapper]').forEach(function (wrapper) {
    var dataEl = wrapper.querySelector('[data-product-json]');
    if (!dataEl) return;

    var product;
    try {
      product = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }

    var form = wrapper.querySelector('form[data-product-form]');
    var idInput = form && form.querySelector('input[name="id"]');
    var priceEl = wrapper.querySelector('[data-price]');
    var compareEl = wrapper.querySelector('[data-compare-price]');
    var inventoryEl = wrapper.querySelector('[data-inventory]');
    var submitBtn = form && form.querySelector('[data-add-button]');
    var moneyFmt = wrapper.dataset.moneyFormat || '';

    function currentOptions() {
      var options = [];
      wrapper.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        var select = group.querySelector('select');
        options[parseInt(group.dataset.optionIndex, 10)] = checked ? checked.value : select ? select.value : null;
      });
      return options;
    }

    function findVariant(options) {
      return product.variants.find(function (variant) {
        return variant.options.every(function (opt, index) { return opt === options[index]; });
      });
    }

    function updateMedia(variant) {
      if (!variant || !variant.featured_media) return;
      var slide = wrapper.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
      var viewport = wrapper.querySelector('[data-gallery-viewport]');
      if (slide && viewport) {
        viewport.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
    }

    function updateState(variant) {
      var addLabel = wrapper.dataset.addLabel || 'Add to cart';
      var soldOutLabel = wrapper.dataset.soldOutLabel || 'Sold out';
      var unavailableLabel = wrapper.dataset.unavailableLabel || 'Unavailable';

      if (!variant) {
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.querySelector('span').textContent = unavailableLabel;
        }
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (priceEl) priceEl.textContent = moneyFormat(variant.price, moneyFmt);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = moneyFormat(variant.compare_at_price, moneyFmt);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.querySelector('span').textContent = variant.available ? addLabel : soldOutLabel;
      }

      if (inventoryEl) {
        inventoryEl.classList.remove('gloam-inventory--low', 'gloam-inventory--out');
        var label = inventoryEl.dataset.inStock;
        if (!variant.available) {
          inventoryEl.classList.add('gloam-inventory--out');
          label = inventoryEl.dataset.outOfStock;
        }
        var textEl = inventoryEl.querySelector('[data-inventory-text]');
        if (textEl && label) textEl.textContent = label;
      }

      // Keep URL shareable per-variant on the main product page only
      if (wrapper.dataset.updateUrl === 'true' && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      updateMedia(variant);
    }

    wrapper.addEventListener('change', function (event) {
      if (!event.target.closest('[data-option-index]')) return;
      updateState(findVariant(currentOptions()));
    });

    /* ------ Media gallery: thumbs, prev/next, zoom ------ */
    var viewport = wrapper.querySelector('[data-gallery-viewport]');
    if (viewport) {
      var slides = Array.prototype.slice.call(viewport.querySelectorAll('[data-media-id]'));
      var thumbs = Array.prototype.slice.call(wrapper.querySelectorAll('[data-gallery-thumb]'));

      function markActive() {
        var index = Math.round(viewport.scrollLeft / viewport.clientWidth);
        thumbs.forEach(function (thumb, i) {
          thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }
      viewport.addEventListener('scroll', function () {
        window.requestAnimationFrame(markActive);
      }, { passive: true });

      thumbs.forEach(function (thumb, index) {
        thumb.addEventListener('click', function () {
          var slide = slides[index];
          if (slide) viewport.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        });
      });

      wrapper.querySelectorAll('[data-gallery-nav]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var direction = parseInt(btn.dataset.galleryNav, 10);
          viewport.scrollBy({ left: viewport.clientWidth * direction, behavior: 'smooth' });
        });
      });

      // Zoom: open the current media's full-resolution image in a simple dialog
      var zoomDialog = wrapper.querySelector('[data-zoom-dialog]');
      wrapper.querySelectorAll('[data-zoom-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!zoomDialog) return;
          var index = Math.round(viewport.scrollLeft / viewport.clientWidth);
          var slide = slides[index];
          var full = slide && slide.querySelector('img');
          var target = zoomDialog.querySelector('img');
          if (full && target) {
            target.src = full.currentSrc || full.src;
            target.alt = full.alt || '';
          }
          if (typeof zoomDialog.showModal === 'function') zoomDialog.showModal();
        });
      });
      if (zoomDialog) {
        zoomDialog.addEventListener('click', function (event) {
          if (event.target === zoomDialog || event.target.closest('[data-zoom-close]')) zoomDialog.close();
        });
      }
    }
  });
})();
